import type { RegionName } from '../types/region'

/** subRegion 필터 칩의 "전체" sentinel — 백엔드 한글 subRegion과 충돌 안 나는 ASCII 값 */
export const ALL_SUB_REGION = 'all' as const

/**
 * 클라 측에서 임시로 가리는 광역권역.
 * 백엔드는 응답에 포함하지만 이번 릴리즈 범위 밖이면 여기서 필터링.
 * 노출 결정되면 비우면 됨.
 */
export const HIDDEN_REGIONS: ReadonlySet<RegionName> = new Set(['경상'])

/**
 * 시도 탭 노출 순서 — 백엔드 응답 순서가 다르더라도 클라가 명시적으로 정렬.
 * 목록에 없는 region 은 뒤에 배치 (Number.MAX_SAFE_INTEGER 로 fallback).
 */
export const REGION_ORDER: readonly RegionName[] = ['서울', '경기', '인천', '경상']

/**
 * REGION_ORDER 기반 정렬용 인덱스.
 * 목록에 없는 region 은 MAX 로 (배열 뒤로 밀림).
 */
export const regionOrderIndex = (r: RegionName): number => {
  const idx = REGION_ORDER.indexOf(r)
  return idx === -1 ? Number.MAX_SAFE_INTEGER : idx
}
